import angular from 'angular';
import appHeaderComponent from './appHeader.component';

let appHeaderModule = angular.module('appHeader', []).component('appHeader', appHeaderComponent);

export default appHeaderModule;



// WEBPACK FOOTER //
// ./app/common/appHeader/appHeader.js